import React from 'react';
import styles from './styles.scss';
const { Fragment, useState, useEffect } = React;
import moment from 'moment-timezone';

import { Line as LineChart } from 'react-chartjs-2';
import Loading from '../../Loading';
import ErrorState from '../../ErrorState';

import {
  AppBar,
  AppBarTitle,
  AppBarSection,
  DatePicker,
} from '@densityco/ui';
import colorVariables from '@densityco/ui/variables/colors.json';

import { ResourceStatus } from '../../../types/resource';
import { SpacesState } from '../../../types/spaces';

const WIDTH = 800,
  HEIGHT = 600,
  PADDING = {
    top: 20,
    bottom: 20,
    left: 20,
    right: 20,
  },
  INNER_WIDTH = WIDTH - PADDING.left - PADDING.right,
  INNER_HEIGHT = HEIGHT - PADDING.top - PADDING.bottom;

const CountsChart: React.FunctionComponent<{
  date: string,
  timeZone: string,
  onChangeDate: (date: string) => void,
  countsResource: SpacesState['counts']['resource'],
}> = ({ timeZone, date, countsResource, onChangeDate }) => {
  const now = moment();
  const [focus, setFocus] = useState(false);

  return (
    <Fragment>
      <AppBar>
        <AppBarTitle>Daily Counts (unbounded at zero)</AppBarTitle>
        <AppBarSection>
          <div style={{ zIndex: 1 }}>
            <DatePicker
              date={moment(date)}
              onChange={date => {
                onChangeDate((date as any).format('YYYY-MM-DD'));
                setFocus(false);
              }}
              focused={focus}
              onFocusChange={focused => setFocus(focused)}
              isOutsideRange={day => moment(day).startOf('day').isAfter(now.clone().startOf('day'))}
              arrowRightDisabled={moment(date).startOf('day').isSameOrAfter(now.clone().startOf('day'))}
              anchor="ANCHOR_RIGHT"
            />
          </div>
        </AppBarSection>
      </AppBar>

      {countsResource.status === ResourceStatus.COMPLETE ? (
        <div className={styles.chartWrapper}>
          <LineChart
            data={{
              labels: countsResource.data.map(i => moment(i.timestamp).format('h:mm:ss a')),
              datasets: [
                {
                  label: "Count",
                  fill: false,
                  pointHoverRadius: 5,
                  pointRadius: 5,
                  pointHitRadius: 10,
                  borderColor: colorVariables.midnight,
                  data: countsResource.data.map(i => i.bucketCount),
                },
              ],
            }}
            width={100}
            height={500}
            options={{ maintainAspectRatio: false, legend: { display: false } }}
          />
        </div>
      ) : null}
      {countsResource.status === ResourceStatus.ERROR ? (
        <ErrorStateWrapped error={countsResource.error} />
      ) : null}
      {countsResource.status === ResourceStatus.LOADING ? (
        <Loading />
      ) : null}
    </Fragment>
  );
};
export default CountsChart;


const ErrorStateWrapped: React.FunctionComponent<{ error: Error }> = ({ error }) => {
  /* if the space is in planning mode, counts will return a 401, so tell the user that

    Note: space status does not currently get included by Sensei
   */
  let errorMessage = '';
  if (error.toString().includes("Invalid authentication credentials")) {
    errorMessage = 'Space is in "planning" mode. Counts will be available once space enters "live" mode.';
    return <ErrorState error={errorMessage} />
  } else {
    return <ErrorState error={error} />
  }
}
